import { getCurrentAdminApplicationCode } from './applicationSession'

export const buildListParams = (params = {}) => ({
  page: 1,
  limit: 25,
  sortDirection: 'asc',
  ...params,
})

export const withCacheBuster = (params = {}) => ({
  ...params,
  _t: Date.now(),
})

export const withApplicationCode = (applicationCode) => ({
  withCredentials: true,
  headers: {
    'x-application-code': applicationCode,
  },
})

export const withSuiteAdminCode = () => withApplicationCode(getCurrentAdminApplicationCode())
